import { render, staticRenderFns } from "./IconSvgPlayerBack.vue?vue&type=template&id=03ad24a6&scoped=true&"
import script from "./IconSvgPlayerBack.vue?vue&type=script&lang=js&"
export * from "./IconSvgPlayerBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ad24a6",
  null
  
)

export default component.exports